import { Route, Routes } from 'react-router-dom';
import AdsList from './AdsList';

function AdsRoutes() {
  return (
    <Routes>
      <Route path="home" element={<AdsList />} />
    </Routes>
  );
}

export default AdsRoutes;
